import Monitoring from "../../../../components/AssetManagement/Health/Monitoring/Monitoring";

function MonitoringScreen() {
  return <Monitoring />;
}

export default MonitoringScreen;
